import {createStore, combineReducers, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import {analysis, story, fullStory} from './reducers/buddyBooks';
import {booklist} from './reducers/storyBooks';
import auth from './reducers/auth';
import settings from "./reducers/settings";
import student from "./reducers/student";

const platform = combineReducers({
    analysis,
    story,
    fullStory,
    booklist,
    auth,
    settings,
    student
});

const rootReducer = combineReducers({platform});

const reduxDevTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

const store = reduxDevTools
    ? createStore(rootReducer, reduxDevTools(applyMiddleware(thunk)))
    : createStore(rootReducer, applyMiddleware(thunk));

export default store;